module.exports = __webpack_public_path__ + "static/img/adv2.3515596e.png";